export default __webpack_public_path__ + "static/media/doc_frontal.5bde9570.svg";